<template>
    <b-table-simple borderless v-if="invoice">
        <b-tbody>
            <b-tr class="row">
                <b-th class="col-4">Subtotal:</b-th>
                <b-td class="col-8">
                    {{ _toCurrency(invoice.sub_total_amount) }}
                </b-td>
            </b-tr>
            <b-tr class="row">
                <b-th class="col-4">Discount:</b-th>
                <b-td class="col-8">
                    {{ _toCurrency(invoice.discount_amount * -1) }}
                </b-td>
            </b-tr>
            <b-tr class="row">
                <b-th class="col-4">Tax:</b-th>
                <b-td class="col-8">
                    {{ _toCurrency(invoice.tax_amount) }}
                </b-td>
            </b-tr>
            <b-tr class="row">
                <b-th class="col-4">Late Fee:</b-th>
                <b-td class="col-8">
                    {{ _toCurrency(invoice.late_fee_amount) }}
                </b-td>
            </b-tr>
            <b-tr
                class="row"
                v-if="(invoice.status == BILLINGS.INVOICE.TYPE_WRITEOFF)"
            >
                <b-th class="col-4">Write Off:</b-th>
                <b-td class="col-8">
                    {{ _toCurrency(invoice.write_off_amount * -1) }}
                </b-td>
            </b-tr>
            <b-tr class="row">
                <b-th class="col-4">Total:</b-th>
                <b-td class="col-8">
                    {{ _toCurrency(invoice.total_amount) }}
                </b-td>
            </b-tr>
            <b-tr class="row">
                <b-th class="col-4">Payment:</b-th>
                <b-td class="col-8">
                    {{ _toCurrency(invoice.payment_amount * -1) }}
                </b-td>
            </b-tr>
            <b-tr class="row" v-if="invoice.return_amount != 'RM0.00'">
                <b-th class="col-4">Return:</b-th>
                <b-td class="col-8">
                    {{ _toCurrency(invoice.return_amount * -1) }}
                </b-td>
            </b-tr>
            <b-tr class="row">
                <b-th class="col-4">Credit:</b-th>
                <b-td class="col-8">
                    {{ _toCurrency(invoice.credit_amount * -1) }}
                </b-td>
            </b-tr>
            <b-tr class="row">
                <b-th class="col-4">Balance:</b-th>
                <b-td class="col-8">
                    {{ _toCurrency(invoice.balance_amount) }}
                </b-td>
            </b-tr>
        </b-tbody>
    </b-table-simple>
</template>

<script>
import BILLINGS from "@/constants/billings";

export default {
    computed: {
        invoice() {
            return this.$store.getters["billing/invoiceDetails"];
        }
    },
    data() {
        return {
            BILLINGS
        };
    }
};
</script>
<style type="text/css" lang="scss" scoped>
.invoice-details th,
.invoice-details td {
    padding: 0px !important;
    line-height: 35px !important;
}
.invoice-details tr {
    padding-left: 1.5rem !important;
}
</style>
